/* Insert only at an existing paragraph boundary; never split article HTML. */
(() => {
  function mount(scope) {
    scope.querySelectorAll('[data-article-promo-template]').forEach((template) => {
      const content = template.previousElementSibling;
      if (!content || !content.matches('[data-article-promo-content]') || content.querySelector('.article-inline-promo')) return;
      let container = content;
      // Some imported articles wrap all their content in one div.
      while (container.children.length === 1 && container.firstElementChild.tagName === 'DIV') {
        container = container.firstElementChild;
      }
      const blocks = Array.from(container.children).filter((element) =>
        !['SCRIPT', 'STYLE', 'TEMPLATE'].includes(element.tagName)
      );
      const weight = (element) => element.textContent.trim().length;
      const total = blocks.reduce((sum, element) => sum + weight(element), 0);
      let seen = 0;
      let best = null;
      let distance = Infinity;
      blocks.forEach((element, index) => {
        seen += weight(element);
        if (element.tagName !== 'P' || !weight(element) || index === blocks.length - 1) return;
        const delta = Math.abs(seen - total / 2);
        if (delta < distance) { best = element; distance = delta; }
      });
      // No safe internal paragraph boundary: leave the article untouched.
      if (!best) return;
      best.after(template.content.cloneNode(true));
    });
  }
  if (!window.molekuleArticlePromoMounted) {
    window.molekuleArticlePromoMounted = true;
    document.addEventListener('shopify:section:load', (event) => mount(event.target));
  }
  mount(document);
})();
